var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProgressTracker',{staticClass:"task-progress-tracker",attrs:{"steps":_vm.steps,"showCheckMarkForCompletedStep":true,"linkItems":_vm.linkItems},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }